//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            loading: true,
            startDate: moment().subtract(30, 'days'),
            endDate: moment(),
            data: {
                url: '/monitoring/activity/',
                method: 'GET'
            },
            chart: {
                datasets: [
                    {
                        label: this.$lang.get('models.monitoring.labels.activity'),
                        data: [],
                        borderColor: '#0f2f45',
                        backgroundColor: '#0f2f45',
                        pointRadius: 6,
                        pointBorderColor: '#ffffff',
                        pointBorderWidth: '2',
                        fill: false,
                        lineTension: 0,
                    },
                ],
                labels: [],
                beginzero: true,
                options: {
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                    },
                    scales: {
                        yAxes: [{
                            position: 'right',
                            offset: false,
                            stacked: false,
                            gridLines: {
                                color: '#0f2f45',
                                drawBorder: false,
                            },
                            ticks: {
                                min: 0,
                                stepSize: 20,
                                fontColor: '#0f2f45',
                                padding: 5,
                            },
                        }],
                        xAxes: [{
                            offset: true,
                            stacked: true,
                            gridLines: [{
                                display: false,
                                drawBorder: false,
                            }],
                            ticks: {
                                fontColor: '#0f2f45',
                                padding: 10,
                            },
                        }]
                    }
                },
            },
        };
    },

    created () {
        this.loadData();
    },

    methods: {
        loadData() {
            this.loading = true;

            axios.request({
                method: this.data.method,
                url: this.data.url,
                params: {
                    start_date: this.startDate.format('YYYY-MM-DD'),
                    end_date: this.endDate.format('YYYY-MM-DD'),
                }
            }).then(response => {
                this.chart.datasets[0].data = response.data.data.data[0];
                this.chart.labels = response.data.data.labels;

                this.loading = false;
            }).catch(error => {
                this.loading = false;
            });
        },
        prev () {
            this.startDate = this.startDate.subtract(30, 'days');
            this.endDate = this.endDate.subtract(30, 'days');
            this.loadData();
        },
        next () {
            this.startDate = this.startDate.add(30, 'days');
            this.endDate = this.endDate.add(30, 'days');
            this.loadData();
        }
    }
};
